module.exports = __webpack_public_path__ + "static/media/caret-square-up.55719f00.svg";